module.exports = __webpack_public_path__ + "assets/azure.c5025422.svg";